import styled from "styled-components";

export const StyledNotEdited = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 24px;
`;

export const Alert = styled.div`
    display: inline-block;
    margin-right: 8px;
    position: relative;
    top: 6px;
    .i-alert {
        font-size: 36px;
        color: ${p => p.theme.c.info};
        display: inline-block;
    }
`;